import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";
import DocumentTypeMapper from "../../documentTypes/service/DocumentTypeMapper";
import DocumentTypeParamMapper from "../../documentTypes/service/DocumentTypeParamMapper";
import Constants from "../common/Constants";

export default class AddOrganisationCaseDecisionTypesInteractor {
  private createResource: CreateResourceInteractor<IDocumentType>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(caseDecisionType: IDocumentType, organisationId: number) {
    return this.createResource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.caseDecisionTypesPath}`,
      DocumentTypeMapper,
      DocumentTypeParamMapper,
      caseDecisionType,
      undefined,
      false
    );
  }
}
